export const SET_ATENDIMENTOS_ABERTOS = 'SET_ATENDIMENTOS_ABERTOS';
export const SET_ATENDIMENTOS_LOADING = 'SET_ATENDIMENTOS_LOADING';
export const SET_ATENDENTES_ONLINE = 'SET_ATENDENTES_ONLINE';
export const SET_HORARIOS_ATENDIMENTOS = 'SET_HORARIOS_ATENDIMENTOS';
export const SET_ATENDIMENTOS_NAO_FINALIZADOS = 'SET_ATENDIMENTOS_NAO_FINALIZADOS';
export const LOADING_HORARIOS_DE_ATENDIMENTO = 'LOADING_HORARIOS_DE_ATENDIMENTO';
export const SET_PLAY_SONG = 'SET_PLAY_SONG';